import { Schema } from "effect";

/** Square location names used for cash and card order filtering. */
export class OkLocations extends Schema.TaggedClass<OkLocations>()(
  "OkLocations",
  {
    locations: Schema.Array(
      Schema.Struct({
        id: Schema.NonEmptyString,
        name: Schema.NonEmptyString,
      }),
    ),
  },
) {}

/** The configured merchant's directory, available before the first order. */
export class OkLocationDirectory extends Schema.TaggedClass<OkLocationDirectory>()(
  "OkLocationDirectory",
  {
    merchantId: Schema.NonEmptyString,
    locations: OkLocations.fields.locations,
  },
) {}

/** A safe provider failure that does not expose Square credentials. */
export class ErrLocationsUnavailable extends Schema.TaggedError<ErrLocationsUnavailable>()(
  "ErrLocationsUnavailable",
  { message: Schema.String },
) {}
